import React from 'react';
import { statusBadge } from '../lib/brand';

export default function StatusBadge({ status, testid }) {
  const { label, cls } = statusBadge(status);
  return (
    <span
      data-testid={testid || 'case-status-badge'}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${cls}`}
    >
      {label}
    </span>
  );
}
